module.exports = __webpack_public_path__ + "img/prize-02.1b5e1f95.png";